<script setup>
    import { ref, computed, onMounted, onUnmounted } from "vue";

    const props = defineProps( {
        content: {
            type: String,
            default: ''
        },
        placement: {
            type: String,
            default: 'bottom',
            validator: (value) => ['top', 'bottom', 'left', 'left-bottom', 'right'].includes(value)
        },
        theme: {
            type: String,
            default: 'light',
            validator: (value) => ['dark', 'light'].includes(value)
        },
        offset: {
            type: Number,
            default: 8
        },
		index: {
			type: Number,
			default: 0,
		}
    })

    const show = ref(null);
	let timer = null;

	const showInfo = (id) => {
		show.value = id;
		clearTimeout(timer);
		timer = setTimeout(() => {
			show.value = null;
		}, 3000);
	};

	const hideInfo = () => {
		show.value = null;
		clearTimeout(timer);
	};

    const tooltipStyle = computed(() => {
        const styles = {};
        if (props.placement === "top") {
            styles.bottom = `calc(100% + ${props.offset}px)`;
        } else if (props.placement === "bottom") {
            styles.top = `calc(100% + ${props.offset}px)`;
        } else if (props.placement === "left") {
            styles.right = `calc(100% + ${props.offset}px)`;
        } else if (props.placement === "left-bottom") {
            styles.right = `calc(-55% + ${props.offset}px)`;
		} else if (props.placement === "right") {
            styles.left = `calc(100% + ${props.offset}px)`;
        }
        return styles;
    });
</script>

<template>
	<div :class="['tooltip-wrapper', { 'active': show }]" ref="tooltipWrapper">
		<div class="tooltip-trigger" @click="showInfo(props.index)" @mouseenter="showInfo(props.index)">
			<slot />
		</div>

		<transition name="tooltip">
			<div v-if="show === props.index" class="tooltip" :class="[placement, theme]" :style="tooltipStyle">
				<button @click.stop="hideInfo" class="tooltip__btn-close"><svg width='20' height='20'><use href='#x'></use></svg></button>
				<div class="tooltip-content">
					<div v-if="content" v-html="content"></div>
					<slot name="content" />
				</div>
				<div class="tooltip-arrow" :class="placement"></div>
			</div>
		</transition>
	</div>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.tooltip-wrapper {
	position: relative;
	display: inline-block;
    cursor: pointer;
}

.tooltip-trigger {
	// display: inline-block;
	display: flex;

	:deep(svg) {
		stroke: transparent;
	}
}

.tooltip {
	position: absolute;
	z-index: 1000;
	// white-space: nowrap;
	// pointer-events: none;
	width: 27rem;
	opacity: 1;
	@media (max-width: vars.$x480) {
		width: 22rem;
	}
	@media (max-width:320px) {
		width: 24rem;
	}
}
.tooltip__btn-close {
	display: grid;
	place-items: center;
	position: absolute;
	top: 3px;
    right: 5px;
	width: 2rem;
	height: 2rem;
	z-index: 1;
	svg {
		width: 100%;
		height: 100%;
		stroke: #ffffff;
	}
}
.tooltip.top {
	left: 50%;
	transform: translateX(-85%);
}

.tooltip.bottom {
	left: 50%;
	transform: translateX(-50%);
}

.tooltip.left {
	top: 50%;
	transform: translateY(-50%);
}
.tooltip.left-bottom {
	top: 140%;
	transform: translateY(0%);
	width: 260px;
}

.tooltip.right {
	top: 50%;
	transform: translateY(-50%);
}

.tooltip-content {
	padding: 16px 20px 16px 16px;
	font-family: var(--font-family);
	font-weight: 500;
	font-size: 1.6rem;
	line-height: 140%;
	color: var(--text-inverse-100);
	@media (max-width: vars.$x480) {
		font-size: 1.3rem;
	}
}

.tooltip.dark .tooltip-content {
	background: #1f2937;
	color: white;
	box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.tooltip.light .tooltip-content {
	border: 1px solid var(--border-accent-2-3);
	border-radius: 1.6rem;
	backdrop-filter: blur(15.399999618530273px);
	box-shadow: inset 0 13px 35px 0 rgba(255, 255, 255, 0.14);
	background: var(--fill-accent-1-1);
	// background: red;
	@media (max-width: vars.$x480) {
		border-radius: 1.6rem;
	}
}

// .tooltip-arrow {
// 	position: absolute;
// 	width: 8px;
// 	height: 8px;
// 	transform: rotate(45deg);
// }

// .tooltip.top .tooltip-arrow {
// 	bottom: -4px;
// 	left: 50%;
// 	transform: translateX(-50%) rotate(45deg);
// }

// .tooltip.bottom .tooltip-arrow {
// 	top: -4px;
// 	left: 50%;
// 	transform: translateX(-50%) rotate(45deg);
// }

// .tooltip.left .tooltip-arrow {
// 	right: -4px;
// 	top: 50%;
// 	transform: translateY(-50%) rotate(45deg);
// }

// .tooltip.left-bottom .tooltip-arrow {
// 	right: 13px;
// 	top: 0%;
// 	transform: translateY(-50%) rotate(45deg);
// 	display: none;
// }

// .tooltip.right .tooltip-arrow {
// 	left: -4px;
// 	top: 50%;
// 	transform: translateY(-50%) rotate(45deg);
// }

// .tooltip.dark .tooltip-arrow {
// 	background: #1f2937;
// }

// .tooltip.light .tooltip-arrow {
// 	background: white;
// 	border: 1px solid #e5e7eb;
// }

// .tooltip.light .tooltip-arrow.top {
// 	border-top: none;
// 	border-left: none;
// }

// .tooltip.light .tooltip-arrow.bottom {
// 	border-bottom: none;
// 	border-right: none;
// }

// .tooltip.light .tooltip-arrow.left {
// 	border-left: none;
// 	border-bottom: none;
// }

// .tooltip.light .tooltip-arrow.left-bottom {
// 	border-right: none;
// 	border-bottom: none;
// }

// .tooltip.light .tooltip-arrow.right {
// 	border-right: none;
// 	border-top: none;
// }

/* Анимации */
.tooltip-enter-active,
.tooltip-leave-active {
	transition: all 0.2s ease;
}

.tooltip-enter-from,
.tooltip-leave-to {
	opacity: 0;
	transform: translateX(-50%) translateY(-4px);
}

.tooltip.top.tooltip-enter-from,
.tooltip.top.tooltip-leave-to {
	transform: translateX(-50%) translateY(-4px);
}

.tooltip.bottom.tooltip-enter-from,
.tooltip.bottom.tooltip-leave-to {
	transform: translateX(-50%) translateY(4px);
}

.tooltip.left.tooltip-enter-from,
.tooltip.left.tooltip-leave-to {
	transform: translateY(-50%) translateX(-4px);
}

.tooltip.right.tooltip-enter-from,
.tooltip.right.tooltip-leave-to {
	transform: translateY(-50%) translateX(4px);
}
</style>
